import api from './api'

const authService = {
  /**
   * Login user
   */
  login(email, password) {
    return api.post('/enercare/api/v1/auth/login/', {
      email,
      password
    })
  },

  /**
   * Register new user
   */
  register(userData) {
    return api.post('/enercare/api/v1/auth/register/', userData)
  },

  /**
   * Refresh JWT token
   */
  refreshToken(refreshToken) {
    return api.post(
      '/enercare/api/v1/auth/refresh/',
      {
        // The endpoint's serializer requires `refresh_token`; the old
        // `refresh` key made every refresh fail with 400 — the very 400 seen
        // in the SEZ-5044 reproduction (SEZ-5044-R06).
        refresh_token: refreshToken
      },
      // The router guard waits on this call before rendering a protected
      // route, and axios has no default timeout, so a hung backend would
      // leave the customer on a blank page for as long as it stays hung.
      { timeout: 10000 }
    )
  },

  /**
   * Request password reset
   */
  requestPasswordReset(email) {
    return api.post('/enercare/api/v1/auth/password-reset/', {
      email
    })
  },

  /**
   * Confirm password reset
   */
  confirmPasswordReset(token, newPassword) {
    return api.post('/enercare/api/v1/auth/password-reset/confirm/', {
      token,
      new_password: newPassword
    })
  },

  /**
   * Logout (optional backend call)
   */
  logout() {
    return api.post('/enercare/api/v1/auth/logout/')
  },

  /**
   * Change password (requires authentication)
   */
  changePassword(currentPassword, newPassword) {
    return api.post('/enercare/api/v1/auth/change-password/', {
      current_password: currentPassword,
      new_password: newPassword
    })
  },

  /**
   * Verify email with token
   */
  verifyEmail(token) {
    return api.post('/enercare/api/v1/auth/verify-email/', { token })
  },

  /**
   * Resend verification email
   */
  resendVerificationEmail(email) {
    return api.post('/enercare/api/v1/auth/resend-verification/', { email })
  },

  deleteAccount(password) {
    return api.post('/enercare/api/v1/auth/delete-account/', {
      password
    })
  }
}

export default authService
